<template>
  <section>
        <!-- Breadcrumb Navigation -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
        <li class="breadcrumb-item"><router-link :to="{name: 'Proceeding', params:{id: proceeding.id}}">Expedientes</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">Editar Expediente</li>
      </ol>
    </nav>
    <h1>Editar Expediente</h1>
    <hr/><br/>

    <form @submit.prevent="submit">
      <div class="mb-3">
        <label for="number" class="form-label">Title:</label>
        <input type="text" name="number" v-model="form.number" class="form-control" />
      </div>
      <div class="mb-3">
        <label for="description" class="form-label">Descripción:</label>
        <textarea
          name="description"
          v-model="form.description"
          class="form-control"
        ></textarea>
      </div>
      <button type="submit" class="btn btn-primary">Guardar</button>
    </form>
  </section>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';

export default defineComponent({
  name: 'EditProceeding',
  props: ['id'],
  data() {
    return {
      form: {
        number: '',
        description: '',
      },
      proceeding_id: '',
    };
  },
  created: function() {
    this.GetProceeding();
  },
  computed: {
    ...mapGetters({ proceeding: 'stateProceeding' }),
  },
  methods: {
    ...mapActions(['updateProceeding', 'viewProceeding']),
    async submit() {
      this.form.user_id = this.proceeding.user_id;
    try {
      let proceeding = {
        id: this.id,
        form: this.form,

      };
      await this.updateProceeding(proceeding);
      this.$router.push({name: 'Proceeding', params:{id: this.proceeding.id}});
    } catch (error) {
      console.log(error);
    }
    },
    async GetProceeding() {
      try {
        await this.viewProceeding(this.id);
        this.form.number = this.proceeding.number;
        this.form.description = this.proceeding.description;
        this.proceeding_id = this.proceeding.id;
      } catch (error) {
        console.error(error);
        this.$router.push('/dashboard');
      }
    }
  },
});
</script>
<style scoped>
.breadcrumb {
  background-color: transparent;
  padding: 0;
  margin-bottom: 1rem;
}
</style>